export default "__VITE_ASSET__CcwTPlYd__"